import React from "react";

const Image = ({ src, alt }) => {
  return (
    <div>
      <img src={src} alt={alt} width="100%" />
    </div>
  );
};

export default Image;
